const config = {
    apiUrl: 'https://apierp.elancelearning.com',
    elantUrl: 'https://0l5hu05ls1.execute-api.ap-south-1.amazonaws.com/prod/api/v1',
    elantAuth: 'Basic dXNlcjpwYXNzd29yZA==',
    partnerId: '67d0155e4e43747d03d053c6',
  };
  
  module.exports = config;